module.exports = {"id":"219814","name":"Sean Klaiber","rating":"71","photo":"./data/images/photos/0/219814.png","club":{"name":"FC Utrecht","logo":"./data/images/clubs/FCUtrecht.png"},"positions":["DD","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SeanKlaiber0.json
// module id = 3848
// module chunks = 0